import React from 'react';
import success from '../../assets/images/newui/sellersignup/success.svg'
import './SignupCompleteSuccess.less'
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import { NavigationUrls } from '../../constants/NavigationUrls';


const SignupCompleteSuccess = ({ history , isTOSEnabled }) => {
    
    setTimeout(() => {
        if(isTOSEnabled)
        {
            if(history.location.pathname.indexOf('agreement') < 0)
            {
                // history.push(NavigationUrls.ACCEPTED_BIDS_URL);
                history.push(NavigationUrls.CUSTOMER_REQUESTS_LIST);
                
            }
        }else
        {
            // history.push(NavigationUrls.ACCEPTED_BIDS_URL);
            history.push(NavigationUrls.CUSTOMER_REQUESTS_LIST);
                
        }
    }, 2000)
        
    return <div className='signup-complete-container'>
        <img src={success} />
        <div className='signup-complete-heading'>Congratulations</div>
        <div className='signup-complete-sub-heading'>You are all set to receive customers from ServiceGrace</div>
        <div className='signup-complete-submit-container'><button className='signup-complete-submit' onClick={() => history.push('')}>Continue<img src={next} /></button></div>
    </div>
}

export default SignupCompleteSuccess;